


import React, { useEffect } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { Button } from "@shared/ui/button";
import { Label } from "@shared/ui/label";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@shared/ui/select";
import { useQueryClient } from '@tanstack/react-query';
import { QueryKeyFactory } from '@shared/api/queries/queryKeyFactory';
import {userFilters} from "../../../types"

// type userFilters = {
//   page: number;
//   limit: number;
//   remote_utility_id: number;
//   department?: string;
//   role?: string;
//   search_data?: string;
// };

interface FilterPanelProps {
  currentFilters: userFilters;
  onApplyFilters: (filters: Partial<userFilters>) => void;
  onResetFilters: () => void;
}

export const FilterPanel: React.FC<FilterPanelProps> = ({
  currentFilters,
  onApplyFilters,
  onResetFilters,
}) => {
  const queryClient = useQueryClient();

  const departmentOptions = queryClient.getQueryData<any[]>(QueryKeyFactory.module.onboarding.departmentOptions());
  const roleOptions = queryClient.getQueryData<any[]>(QueryKeyFactory.module.onboarding.roleOptions());

  const form = useForm({
    defaultValues: {
      department: currentFilters.department || 'ALL_DEPARTMENTS',
      role: currentFilters.role || 'ALL_ROLES',
    },
  });

  useEffect(() => {
    form.setValue('department', currentFilters.department || 'ALL_DEPARTMENTS');
    form.setValue('role', currentFilters.role || 'ALL_ROLES');
  }, [currentFilters, form]);

  const handleApplyFilters = (data: any) => {

    const filtersToApply: Partial<userFilters> = {};

    if (data.department && data.department !== 'ALL_DEPARTMENTS') {
        console.log('inside of deptartment')
      filtersToApply.department = data.department;
    }

    if (data.role && data.role !== 'ALL_ROLES') {
         console.log('inside of roles')

      filtersToApply.role = data.role;
    }
    console.log('fileters to apply',filtersToApply)
    onApplyFilters(filtersToApply);
  };

  const handleResetFilters = () => {
    form.reset({
      department: 'ALL_DEPARTMENTS',
      role: 'ALL_ROLES',
    });
    onResetFilters();
  };

  return (
    <form onSubmit={form.handleSubmit(handleApplyFilters)}>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-6">
        <div className="space-y-2">
          <Label>Department</Label>
          <Controller
            name="department"
            control={form.control}
            render={({ field }) => (
              <Select value={field.value} onValueChange={field.onChange}>
                <SelectTrigger>
                  <SelectValue placeholder="Select department" />
                </SelectTrigger>
                <SelectContent>
                  <SelectGroup>
                    <SelectItem value="ALL_DEPARTMENTS">All Departments</SelectItem>
                    {departmentOptions?.map((dept) => (
                      <SelectItem key={dept.name} value={dept.name}>
                        {dept.name}
                      </SelectItem>
                    ))}
                  </SelectGroup>
                </SelectContent>
              </Select>
            )}
          />
        </div>

        <div className="space-y-2">
          <Label>Role</Label>
          <Controller
            name="role"
            control={form.control}
            render={({ field }) => (
              <Select value={field.value} onValueChange={field.onChange}>
                <SelectTrigger>
                  <SelectValue placeholder="Select role" />
                </SelectTrigger>
                <SelectContent>
                  <SelectGroup>
                    <SelectItem value="ALL_ROLES">All Roles</SelectItem>
                    {roleOptions?.map((role) => (
                      <SelectItem key={role.code} value={role.code}>
                        {role.code}
                      </SelectItem>
                    ))}
                  </SelectGroup>
                </SelectContent>
              </Select>
            )}
          />
        </div>

        <div className="col-span-1 md:col-span-2 lg:col-span-2 flex justify-end gap-2">
          <Button type="button" variant="outline" onClick={handleResetFilters}>
            Reset Filters
          </Button>
          <Button type="submit">Apply Filters</Button>
        </div>
      </div>
    </form>
  );
};
